import { createTheme } from "@mui/material/styles";
import "@mui/x-data-grid/themeAugmentation";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#0b8e8b",
      dark: "#0a6b69",
      light: "#3fb9b2",
    },
    secondary: {
      main: "#f0a832",
      dark: "#d38b1b",
      light: "#f6c05f",
    },
    background: {
      default: "#f6fbfb",
      paper: "#ffffff",
    },
    text: {
      primary: "#0d1b2a",
      secondary: "#3b4d5f",
    },
  },
  typography: {
    fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif",
    h1: {
      fontFamily: "'Sora', 'DM Sans', sans-serif",
      fontWeight: 700,
      letterSpacing: "-0.03em",
    },
    h2: {
      fontFamily: "'Sora', 'DM Sans', sans-serif",
      fontWeight: 700,
      letterSpacing: "-0.02em",
    },
    h3: {
      fontFamily: "'Sora', 'DM Sans', sans-serif",
      fontWeight: 700,
      letterSpacing: "-0.02em",
    },
    h4: {
      fontFamily: "'Sora', 'DM Sans', sans-serif",
      fontWeight: 700,
    },
    h5: {
      fontFamily: "'Sora', 'DM Sans', sans-serif",
      fontWeight: 600,
    },
    button: {
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 18,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: "rgba(7, 24, 33, 0.9)",
          backdropFilter: "blur(14px)",
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: 72,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 999,
          paddingInline: 18,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 22,
          boxShadow: "0 18px 40px rgba(8, 31, 45, 0.1)",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          backgroundColor: "#eef3f6",
          borderRadius: 999,
          padding: 4,
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          border: "none",
          borderRadius: 999,
          textTransform: "none",
          fontWeight: 600,
          padding: "6px 18px",
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: "none",
          backgroundColor: "#ffffff",
        },
        columnHeaders: {
          backgroundColor: "#f1f6f8",
          borderBottom: "none",
        },
        row: {
          borderBottom: "1px solid rgba(12, 28, 41, 0.06)",
        },
        cell: {
          borderBottom: "none",
        },
      },
    },
  },
});

export default theme;
